import { render, staticRenderFns } from "./gestionCodigosLista.vue?vue&type=template&id=38a7d036&scoped=true"
import script from "./gestionCodigosLista.vue?vue&type=script&lang=js"
export * from "./gestionCodigosLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a7d036",
  null
  
)

export default component.exports